import { IDefineCommand } from 'core-ts-types';
import { IDatasource, ORM } from 'utility-ts-orm';

import { IStudyGroupMembersDatasource } from '../datasources/study_group_members_datasource';
import { IStudyGroupMember } from '../study_group_interfaces';

angular
  .module('capability-ng-study-groups')
  .factory(
    'clearAllSelectedUsersCommand',
    function clearAllSelectedUsersCommandDefinition(
      defineCommand: IDefineCommand,
      ngStudyGroupMembersDatasource: IStudyGroupMembersDatasource
    ): void {
      return defineCommand(
        'clearAllSelectedUsersCommand',
        function clearAllSelectedUsersCommand(deferred: ng.IDeferred<any>): any {
          ngStudyGroupMembersDatasource.remap((member: IStudyGroupMember) => {
            member._isChecked = false;
            return member;
          });
          ORM.run(ngStudyGroupMembersDatasource);
          deferred.resolve();
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-study-groups/src/commands/clear_all_selected_users_command.ts